import { Toast } from "primereact/toast"
import MeaButton from "../../../../components/MeaButton"
import { useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { ToFormatedBackendDateFromShortISODateString, ToFormatedShortISODateFromDateString } from "../../../../utils/dates";
import MeaMemberAvatar from "../../../../components/MeaMemberAvatar";
import { Checkbox } from "primereact/checkbox";
import membersAPI from "../../../../services/members";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";
import MeaDataTable from "../../../../components/MeaDataTable";
import { Column } from "primereact/column";
import studentsAPI from "../../../../services/students";
import { Messages } from "primereact/messages";
import { Button } from "primereact/button";
import MeaStudentStatus2 from "../../../../components/MeaStudentStatus2";
import MeaStudentResult from "../../../../components/MeaStudentResult";
import { InputTextarea } from "primereact/inputtextarea";
import { useNavigate } from "react-router-dom";
import MeaStudentGender from "../../components/MeaStudentGender";


const NewRegistrationFormComponent = ({ schoolId, trainingId }) => {
  //
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const navigate = useNavigate();
  const accessToken = "";
  //
  const [loading, setLoading] = useState(false);
  //
  const toast = useRef();
  const stepperRef = useRef(null);
  const searchStudentsTableRef = useRef(null);
  const msgs1 = useRef(null);
  const msgs2 = useRef(null);
  //
  const [currentStudent, setCurrentStudent] = useState();
  const [previousRegistration, setPreviousRegistration] = useState([]);
  const updateStudentField = (field, value) => {
    let updated = {};
    updated[field] = value;
    setCurrentStudent((s) => ({
      ...s,
      ...updated,
    }));
  };
  //
  const querySearchStudentsList = membersAPI.useSearchStudentMembers(
    schoolId,
    accessToken,
    page,
    pageSize,
    {
      lastname: currentStudent?.lastname || "",
      firstname: currentStudent?.firstname || "",
      birthday: currentStudent?.birthday || "",
    }
  );
  //
  const verifySelectedStudent = () => {
    setLoading(true)
    const selected = searchStudentsTableRef.current.getSelectedElements();
    if (selected === null || selected === undefined || selected?.length === 0) {
      if (msgs1.current) {
        msgs1.current.clear();
        msgs1.current.show({ id: '1', sticky: true, severity: 'warn', summary: 'Avertissement', detail: 'Aucun élève séléctionné', closable: true });
      }
      setLoading(false)
    } else {
      // verify if he/she is already registered
      studentsAPI.SearchStudent(schoolId, trainingId, accessToken, 1, 1000, { member_id: selected.id }).then((data) => {
        if (data?.total > 0) {
          if (msgs1.current) {
            msgs1.current.clear();
            msgs1.current.show({ id: '1', sticky: true, severity: 'error', summary: 'Avertissement', detail: "L'élève " + selected?.lastname + " " + selected?.firstname + " est déjà inscrit à cette formation", closable: true });
          }
        } else {
          setCurrentStudent({
            member_id: selected.id || "",
            member: selected || "",
            lastname: selected.lastname || "",
            firstname: selected.firstname || "",
            birthday: selected.birthday || "",
            gender: selected.gender || "",
            email: selected.email || "",
            phone: selected.phone || "",
            address: selected.address || "",
            postal_code: selected.postal_code || "",
            city: selected.city || "",
          });
          membersAPI.GetMemberTrainingsRegistrations(schoolId, accessToken, selected.id).then((data) => {
            setPreviousRegistration(data?.data);
          }).catch((error) => {
            console.log("error", error);
          })
          //stepperRef.current.nextCallback();
        }
      }).catch((error) => {
        console.log("error", error);
      }
      ).finally(() => {
        setLoading(false)
      });
    }
  };
  const createStudent = () => {
    setLoading(true);
    if (currentStudent.lastname === "" || currentStudent.firstname === "") {
      if (msgs2.current) {
        msgs2.current.clear();
        msgs2.current.show({ id: '2', sticky: true, severity: 'error', summary: 'Erreur', detail: 'Nom et prénom sont obligatoires', closable: true });
      }
    } else {
      studentsAPI.CreateOne(schoolId, trainingId, accessToken, currentStudent).then((data) => {

        setCurrentStudent(data?.data);
        stepperRef.current.nextCallback();
      }).catch((error) => {
        console.log("error", error);
        if (msgs2.current) {
          msgs2.current.clear();
          msgs2.current.show({ id: '2', sticky: true, severity: 'error', summary: 'Erreur', detail: 'Erreur lors de la création du dossier de candidature: ' + error?.message, closable: true });
        }
      }).finally(() => {
        setLoading(false);
      });

    }
    setLoading(false);
  }


  return (
    <div className="w-full mt-5">
      <Toast ref={toast} position="bottom-center" />
      <Stepper ref={stepperRef} style={{ flexBasis: '50rem' }} linear activeStep={0}>
        <StepperPanel header="Elève">
          <div className="flex flex-column mt-3">
            <div className="mb-4">Utiliser un ou plusieurs des champs suivants pour rechercher si l'élève est déjà présent dans la base de données</div>

            <div className="text-900 w-full md:w-10 md:flex-order-0 flex-order-1">
              <ul className="list-none p-0 m-0">
                <li className="flex align-items-start py-3 px-2 border-top-1 surface-border flex-wrap">

                  <div className="text-900 w-full md:w-10 md:flex-order-0 flex-order-1">
                    <ul className="list-none p-0 m-0">

                      <li className="flex align-items-start py-2 px-2 flex-wrap surface-ground">
                        <div className="text-500 w-full md:w-3 font-medium">Nom de famille</div>
                        <div className="p-inputgroup flex-1">
                          <InputText type="text" className="p-inputtext-sm w-full md:w-9" value={currentStudent?.lastname} onInput={(e) => {
                            updateStudentField("lastname", e.target.value?.toUpperCase())
                          }} />
                          <Button icon="pi pi-times" outlined className="p-button-plain" onClick={() => {
                            updateStudentField("lastname", "")
                          }} />
                        </div>
                      </li>
                      <li className="flex align-items-start py-2 px-2 flex-wrap">
                        <div className="text-500 w-full md:w-3 font-medium">Prénom</div>
                        <div className="p-inputgroup flex-1">
                          <InputText type="text" className="p-inputtext-sm w-full md:w-9" value={currentStudent?.firstname} onInput={(e) => {
                            updateStudentField("firstname", e.target.value?.toUpperCase())
                          }} />
                          <Button icon="pi pi-times" outlined className="p-button-plain" onClick={() => {
                            updateStudentField("firstname", "")
                          }} />
                        </div>
                      </li>
                      <li className="flex align-items-start py-2 px-2 flex-wrap">
                        <div className="text-500 w-full md:w-3 font-medium">Date de naissance</div>
                        <div className="p-inputgroup flex-1">
                          <InputText type="date" className="p-inputtext-sm w-full md:w-9" value={ToFormatedShortISODateFromDateString(currentStudent?.birthday)} onChange={(e) => {
                            updateStudentField("birthday", ToFormatedBackendDateFromShortISODateString(e.target.value))
                          }} />
                          <Button icon="pi pi-times" outlined className="p-button-plain" onClick={() => {
                            updateStudentField("birthday", null)
                          }} />
                        </div>

                      </li>
                      <li className="flex align-items-start py-2 px-2 flex-wrap surface-ground">
                        <div className="text-500 w-full md:w-3 font-medium">Ancien élève</div>
                        {currentStudent?.member_id && <div className="text-900 w-full md:w-9">
                          <div className="flex justify-content-between">
                            <MeaMemberAvatar member={currentStudent?.member} noNavigation={false} />
                            <MeaButton label="Changer" size="small" outlined icon="pi pi-pencil" onClick={() => {
                              updateStudentField("member_id", null)
                              updateStudentField("member", null)
                            }} />
                          </div>
                        </div> ||
                          <div className="text-900 w-full md:w-9">
                            <MeaDataTable
                              ref={searchStudentsTableRef}
                              query={querySearchStudentsList}
                              serviceAPI={membersAPI}
                              showFilterButton={false}
                              names={{ pagination: "student", singular: "élève", plural: "élèves" }}
                              setPage={setPage}
                              setPageSize={setPageSize}>
                              <Column
                                selectionMode="single"
                                headerStyle={{ width: "3rem" }}
                              ></Column>
                              <Column
                                field="id"
                                header="Immatriculation"
                              ></Column>
                              <Column
                                field="lastname"
                                header="Nom de famille"
                              ></Column>
                              <Column
                                field="firstname"
                                header="Prénom"
                              ></Column>
                              <Column
                                field="birthday"
                                header="Date de naissance"
                              ></Column>
                              <Column
                                field="gender"
                                header="Genre"
                                body={(rowData) => {
                                  return <MeaStudentGender gender={rowData?.gender} />
                                }}
                              ></Column>
                            </MeaDataTable>
                            <Messages ref={msgs1} />
                            <MeaButton label="Confirmer" icon="pi pi-check" onClick={verifySelectedStudent} loading={loading} outlined />
                          </div>}
                      </li>
                      <li className="flex align-items-start py-2 px-2 flex-wrap surface-ground">
                        <div className="text-500 w-full md:w-3 font-medium">N° Immatriculation</div>
                        <InputText type="text" disabled className="p-inputtext-sm w-full md:w-9" value={currentStudent?.member_id} onInput={(e) => {
                          updateStudentField("id", e.target.value?.toUpperCase())
                        }} />
                      </li>

                      <li className="flex align-items-start py-2 px-2 flex-wrap surface-ground">
                        <div className="text-500 w-full md:w-3 font-medium">Genre</div>
                        <Dropdown
                          className="p-inputtext-sm w-full md:w-9"
                          value={currentStudent?.gender}
                          checkmark={true}
                          onChange={(e) => { updateStudentField("gender", e.value) }}
                          options={[
                            { label: "", code: "" },
                            { label: "Fille", code: "G" },
                            { label: "Garçon", code: "B" },
                          ]}
                          optionLabel="label"
                          optionValue="code"
                          placeholder="Genre"
                        />
                      </li>

                      <li className="flex align-items-start py-2 px-2 flex-wrap surface-ground">
                        <div className="text-500 w-full md:w-3 font-medium">Code postale</div>
                        <InputText type="text" className="p-inputtext-sm w-full md:w-9" value={currentStudent?.postal_code} onInput={(e) => {
                          updateStudentField("postal_code", e.target.value)
                        }} />
                      </li>
                      <li className="flex align-items-center py-2 px-2 flex-wrap surface-ground">
                        <div className="text-500 w-full md:w-3 font-medium">Formation précédente</div>

                        <Dropdown className="w-full md:w-9" value={currentStudent?.previous_training_id || ""}
                          onChange={(e) => { updateStudentField("previous_training_id", e.value); }}
                          options={previousRegistration}
                          itemTemplate={(option) => {
                            return (
                              <div className="flex flex-wrap align-items-center ">
                                <div className="font-medium">{option?.training?.name || ""}</div>
                                <div className="text-900 ml-2"><MeaStudentStatus2 student={option} /></div>
                              </div>
                            )
                          }}
                          valueTemplate={(option) => {
                            return (
                              <div className="flex flex-wrap align-items-center ">
                                <div className="font-medium">{option?.training?.name || ""}</div>
                                <div className="text-900 ml-2"><MeaStudentStatus2 student={option} /></div>
                                <div className="text-900 ml-2"><MeaStudentResult student={option} /></div>
                              </div>
                            )
                          }}
                          optionLabel="name"
                          optionValue="training.id"
                        />

                      </li>
                      <li className="flex align-items-center py-2 px-2 flex-wrap surface-ground">
                        <div className="text-500 w-full md:w-3 font-medium">Remarques</div>
                        <InputTextarea type="text" rows={8} className="p-inputtext-sm w-full md:w-9" value={currentStudent?.registration_details || ""} onInput={(e) => {
                          updateStudentField("registration_details", e.target.value)
                        }} />
                      </li>
                    </ul>

                    <ul className="list-none p-0 m-0 mt-4">
                      <li className="flex align-items-start py-2 px-2 flex-wrap">
                        <>
                          <div className="flex ">
                            <Messages ref={msgs2} />
                          </div>
                          {false && <MeaButton label="Suivant" icon="pi pi-arrow-right" className="p-button" onClick={() => {
                            stepperRef.current.nextCallback();
                          }} />}
                          <MeaButton disabled={!currentStudent?.lastname && !currentStudent?.firstname} label="Créer le dossier d'inscription" icon="pi pi-save" className="p-button" onClick={createStudent} />
                        </>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul >
            </div>

          </div>
        </StepperPanel>

        <StepperPanel header="Finale">
          <div className="flex flex-column">
            <div className="flex flex-column align-items-center my-4">
              <span className="flex align-items-center justify-content-center bg-cyan-100 text-cyan-800 mr-3 border-circle mb-3" style={{ width: '64px', height: '64px' }}>
                <i className="pi pi-check text-5xl"></i>
              </span>
              <div className="font-medium text-2xl text-900">Dossier de candidature créé</div>
              <div className="font-medium text-xl mt-4 text-900">{currentStudent?.lastname} {currentStudent?.firstname}</div>
            </div>
            <div className="flex flex-column align-items-center my-1">
              <p className="line-height-3 ">
                Vous pouvez consulter le dossier ou créer une nouvelle candidature.
              </p>
            </div>
          </div>
          <div className="flex py-4 flex-column align-items-center">
            <MeaButton label="Consulter le dossier" severity="secondary" icon="pi pi-book" onClick={() => {
              navigate("/school/" + schoolId + "/admin/registrations/" + trainingId + "/candidates/" + currentStudent?.id);
            }} />
            <MeaButton label="Créer une nouvelle candidature" icon="pi pi-plus" className="mt-2" onClick={() => {
              stepperRef.current.setActiveStep(0);
            }} />
            <MeaButton label="Liste des dossiers" outlined className="mt-2" onClick={() => {
              navigate("/school/" + schoolId + "/admin/registrations/" + trainingId + "/candidates");
            }} />
          </div>
        </StepperPanel>
      </Stepper>
    </div>
  )
}

export default NewRegistrationFormComponent;